import React, { useState, useEffect } from "react";
import { useDarkMode } from "../../contexts/DarkModeContext";
import { useNavigate } from "react-router-dom";
import styles from "../Library/Library.module.css";

function SmartQuestions() {
  const { isDarkMode } = useDarkMode();
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("الكل");
  const [searchQuery, setSearchQuery] = useState("");
  const [modalBook, setModalBook] = useState(null);
  const [showQuestions, setShowQuestions] = useState(false);
  const [showPDFViewer, setShowPDFViewer] = useState(false);
  const [selectedPDF, setSelectedPDF] = useState(null);

  // 1. Scroll to books section on search
  const booksSectionRef = React.useRef(null);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setTimeout(() => {
      if (booksSectionRef.current) {
        booksSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  // الأسئلة التدريبية الثابتة
  const questions = [
    // رياضيات - 15 سؤال
    {
      question: "ما هو ناتج: 15 × 8 + 12 ÷ 3؟",
      options: ["120", "124", "128", "132"],
      correctAnswer: "124",
      explanation: "نحسب الضرب أولاً: 15 × 8 = 120، ثم القسمة: 12 ÷ 3 = 4، ثم الجمع: 120 + 4 = 124",
      subject: "رياضيات",
      showAnswer: false
    },
    {
      question: "أوجد قيمة x في المعادلة: 3x + 7 = 22",
      options: ["3", "5", "7", "9"],
      correctAnswer: "5",
      explanation: "3x + 7 = 22، 3x = 22 - 7 = 15، x = 15 ÷ 3 = 5",
      subject: "رياضيات",
      showAnswer: false
    },
    {
      question: "ما هو محيط دائرة نصف قطرها 5 سم؟",
      options: ["10π سم", "15π سم", "20π سم", "25π سم"],
      correctAnswer: "10π سم",
      explanation: "محيط الدائرة = 2πr = 2 × π × 5 = 10π سم",
      subject: "رياضيات",
      showAnswer: false
    },
    {
      question: "أوجد مساحة مثلث قاعدته 8 سم وارتفاعه 6 سم؟",
      options: ["12 سم²", "24 سم²", "48 سم²", "96 سم²"],
      correctAnswer: "24 سم²",
      explanation: "مساحة المثلث = (القاعدة × الارتفاع) ÷ 2 = (8 × 6) ÷ 2 = 24 سم²",
      subject: "رياضيات",
      showAnswer: false
    },
    {
      question: "ما هو الجذر التربيعي للعدد 144؟",
      options: ["10", "11", "12", "13"],
      correctAnswer: "12",
      explanation: "12 × 12 = 144، إذن الجذر التربيعي لـ 144 هو 12",
      subject: "رياضيات",
      showAnswer: false
    },
    {
      question: "أوجد قيمة: (-3)² × 2 + 10",
      options: ["4", "16", "28", "34"],
      correctAnswer: "28",
      explanation: "(-3)² = 9، 9 × 2 = 18، 18 + 10 = 28",
      subject: "رياضيات",
      showAnswer: false
    },
    {
      question: "ما هو ناتج: 2/3 + 1/6؟",
      options: ["1/2", "3/6", "5/6", "7/6"],
      correctAnswer: "5/6",
      explanation: "2/3 = 4/6، 4/6 + 1/6 = 5/6",
      subject: "رياضيات",
      showAnswer: false
    },
    {
      question: "أوجد قيمة x في المعادلة: x² - 9 = 0",
      options: ["±3", "±6", "±9", "±12"],
      correctAnswer: "±3",
      explanation: "x² = 9، x = ±√9 = ±3",
      subject: "رياضيات",
      showAnswer: false
    },
    {
      question: "ما هو ناتج: log₁₀(1000)؟",
      options: ["1", "2", "3", "4"],
      correctAnswer: "3",
      explanation: "log₁₀(1000) = log₁₀(10³) = 3",
      subject: "رياضيات",
      showAnswer: false
    },
    {
      question: "أوجد قيمة: sin(30°)؟",
      options: ["1/4", "1/3", "1/2", "1"],
      correctAnswer: "1/2",
      explanation: "sin(30°) = 1/2",
      subject: "رياضيات",
      showAnswer: false
    },
    {
      question: "ما هو ناتج: 5!؟",
      options: ["60", "120", "720", "5040"],
      correctAnswer: "120",
      explanation: "5! = 5 × 4 × 3 × 2 × 1 = 120",
      subject: "رياضيات",
      showAnswer: false
    },
    {
      question: "أوجد قيمة: 2⁴ × 2³؟",
      options: ["2⁷", "2¹²", "2⁴⁹", "2⁶⁴"],
      correctAnswer: "2⁷",
      explanation: "2⁴ × 2³ = 2⁴⁺³ = 2⁷",
      subject: "رياضيات",
      showAnswer: false
    },
    {
      question: "ما هو ناتج: √(16 + 9)؟",
      options: ["3", "5", "7", "9"],
      correctAnswer: "5",
      explanation: "√(16 + 9) = √25 = 5",
      subject: "رياضيات",
      showAnswer: false
    },
    {
      question: "أوجد قيمة: 3x + 2y إذا كان x = 4 و y = 5؟",
      options: ["22", "23", "24", "25"],
      correctAnswer: "22",
      explanation: "3(4) + 2(5) = 12 + 10 = 22",
      subject: "رياضيات",
      showAnswer: false
    },
    {
      question: "ما هو ناتج: 0.25 × 0.4؟",
      options: ["0.01", "0.1", "0.65", "1"],
      correctAnswer: "0.1",
      explanation: "0.25 × 0.4 = 0.1",
      subject: "رياضيات",
      showAnswer: false
    },

    // فيزياء - 10 أسئلة
    {
      question: "ما هي وحدة قياس القوة في النظام الدولي؟",
      options: ["جول", "نيوتن", "واط", "باسكال"],
      correctAnswer: "نيوتن",
      explanation: "وحدة قياس القوة في النظام الدولي هي النيوتن (N)",
      subject: "فيزياء",
      showAnswer: false
    },
    {
      question: "ما هو قانون نيوتن الأول؟",
      options: ["قانون الحركة", "قانون الجاذبية", "قانون القصور الذاتي", "قانون الفعل ورد الفعل"],
      correctAnswer: "قانون القصور الذاتي",
      explanation: "الجسم الساكن يبقى ساكناً والجسم المتحرك بسرعة ثابتة يبقى متحركاً ما لم تؤثر عليه قوة خارجية",
      subject: "فيزياء",
      showAnswer: false
    },
    {
      question: "ما هي الصيغة الرياضية لقانون نيوتن الثاني؟",
      options: ["F = ma", "F = mg", "F = mv", "F = mgh"],
      correctAnswer: "F = ma",
      explanation: "القوة = الكتلة × التسارع (F = ma)",
      subject: "فيزياء",
      showAnswer: false
    },
    {
      question: "ما هي وحدة قياس الطاقة؟",
      options: ["نيوتن", "جول", "واط", "هرتز"],
      correctAnswer: "جول",
      explanation: "وحدة قياس الطاقة في النظام الدولي هي الجول (J)",
      subject: "فيزياء",
      showAnswer: false
    },
    {
      question: "ما هو قانون حفظ الطاقة؟",
      options: ["الطاقة لا تفنى ولا تستحدث", "الطاقة تزداد مع الزمن", "الطاقة تنقص مع الزمن", "الطاقة ثابتة دائماً"],
      correctAnswer: "الطاقة لا تفنى ولا تستحدث",
      explanation: "الطاقة لا تفنى ولا تستحدث من العدم، بل تتحول من شكل إلى آخر",
      subject: "فيزياء",
      showAnswer: false
    },
    {
      question: "ما هي سرعة الضوء في الفراغ؟",
      options: ["3 × 10⁸ م/ث", "3 × 10⁵ م/ث", "3 × 10¹⁰ م/ث", "3 × 10¹² م/ث"],
      correctAnswer: "3 × 10⁸ م/ث",
      explanation: "سرعة الضوء في الفراغ = 3 × 10⁸ متر/ثانية",
      subject: "فيزياء",
      showAnswer: false
    },
    {
      question: "ما هو قانون أوم؟",
      options: ["V = IR", "P = VI", "F = ma", "E = mc²"],
      correctAnswer: "V = IR",
      explanation: "الجهد = التيار × المقاومة (V = IR)",
      subject: "فيزياء",
      showAnswer: false
    },
    {
      question: "ما هي وحدة قياس القدرة الكهربائية؟",
      options: ["فولت", "أمبير", "واط", "أوم"],
      correctAnswer: "واط",
      explanation: "وحدة قياس القدرة الكهربائية هي الواط (W)",
      subject: "فيزياء",
      showAnswer: false
    },
    {
      question: "ما هو قانون الجاذبية لنيوتن؟",
      options: ["F = G(m₁m₂)/r²", "F = ma", "F = kx", "F = mg"],
      correctAnswer: "F = G(m₁m₂)/r²",
      explanation: "قانون الجاذبية: F = G(m₁m₂)/r² حيث G ثابت الجاذبية",
      subject: "فيزياء",
      showAnswer: false
    },
    {
      question: "ما هي وحدة قياس التردد؟",
      options: ["متر/ثانية", "هرتز", "واط", "جول"],
      correctAnswer: "هرتز",
      explanation: "وحدة قياس التردد هي الهرتز (Hz)",
      subject: "فيزياء",
      showAnswer: false
    },

    // كيمياء - 10 أسئلة
    {
      question: "ما هو الرقم الذري للكربون؟",
      options: ["4", "6", "8", "12"],
      correctAnswer: "6",
      explanation: "الرقم الذري للكربون هو 6",
      subject: "كيمياء",
      showAnswer: false
    },
    {
      question: "ما هي الصيغة الكيميائية للماء؟",
      options: ["H₂O", "CO₂", "O₂", "N₂"],
      correctAnswer: "H₂O",
      explanation: "الصيغة الكيميائية للماء هي H₂O",
      subject: "كيمياء",
      showAnswer: false
    },
    {
      question: "ما هو الرمز الكيميائي للحديد؟",
      options: ["Fe", "Fe₂", "Iron", "Ir"],
      correctAnswer: "Fe",
      explanation: "الرمز الكيميائي للحديد هو Fe",
      subject: "كيمياء",
      showAnswer: false
    },
    {
      question: "ما هي درجة حرارة غليان الماء عند الضغط الجوي العادي؟",
      options: ["50°م", "75°م", "100°م", "150°م"],
      correctAnswer: "100°م",
      explanation: "درجة حرارة غليان الماء عند الضغط الجوي العادي هي 100°م",
      subject: "كيمياء",
      showAnswer: false
    },
    {
      question: "ما هو الرقم الذري للهيدروجين؟",
      options: ["1", "2", "3", "4"],
      correctAnswer: "1",
      explanation: "الرقم الذري للهيدروجين هو 1",
      subject: "كيمياء",
      showAnswer: false
    },
    {
      question: "ما هي الصيغة الكيميائية لثاني أكسيد الكربون؟",
      options: ["CO", "CO₂", "C₂O", "C₂O₄"],
      correctAnswer: "CO₂",
      explanation: "الصيغة الكيميائية لثاني أكسيد الكربون هي CO₂",
      subject: "كيمياء",
      showAnswer: false
    },
    {
      question: "ما هو الرمز الكيميائي للأكسجين؟",
      options: ["O", "O₂", "Ox", "O₃"],
      correctAnswer: "O",
      explanation: "الرمز الكيميائي للأكسجين هو O",
      subject: "كيمياء",
      showAnswer: false
    },
    {
      question: "ما هي درجة حرارة انصهار الجليد؟",
      options: ["-10°م", "0°م", "10°م", "20°م"],
      correctAnswer: "0°م",
      explanation: "درجة حرارة انصهار الجليد هي 0°م",
      subject: "كيمياء",
      showAnswer: false
    },
    {
      question: "ما هو الرقم الذري للنيتروجين؟",
      options: ["5", "6", "7", "8"],
      correctAnswer: "7",
      explanation: "الرقم الذري للنيتروجين هو 7",
      subject: "كيمياء",
      showAnswer: false
    },
    {
      question: "ما هي الصيغة الكيميائية للأمونيا؟",
      options: ["NH₃", "NO₂", "N₂O", "N₂H₄"],
      correctAnswer: "NH₃",
      explanation: "الصيغة الكيميائية للأمونيا هي NH₃",
      subject: "كيمياء",
      showAnswer: false
    },

    // أحياء - 8 أسئلة
    {
      question: "ما هو العضو المسؤول عن ضخ الدم في الجسم؟",
      options: ["الرئتان", "القلب", "الكبد", "الدماغ"],
      correctAnswer: "القلب",
      explanation: "القلب هو العضو المسؤول عن ضخ الدم في الجسم",
      subject: "أحياء",
      showAnswer: false
    },
    {
      question: "ما هي الخلية المسؤولة عن حمل الأكسجين في الدم؟",
      options: ["خلايا الدم البيضاء", "خلايا الدم الحمراء", "الصفائح الدموية", "البلازما"],
      correctAnswer: "خلايا الدم الحمراء",
      explanation: "خلايا الدم الحمراء هي المسؤولة عن حمل الأكسجين في الدم",
      subject: "أحياء",
      showAnswer: false
    },
    {
      question: "ما هو العضو المسؤول عن التنفس في الإنسان؟",
      options: ["القلب", "الرئتان", "الكبد", "الكلية"],
      correctAnswer: "الرئتان",
      explanation: "الرئتان هما العضوان المسؤولان عن التنفس في الإنسان",
      subject: "أحياء",
      showAnswer: false
    },
    {
      question: "ما هو عدد الكروموسومات في الخلية البشرية؟",
      options: ["23", "46", "44", "48"],
      correctAnswer: "46",
      explanation: "عدد الكروموسومات في الخلية البشرية هو 46 كروموسوم",
      subject: "أحياء",
      showAnswer: false
    },
    {
      question: "ما هو العضو المسؤول عن تنظيف الدم من الفضلات؟",
      options: ["الكبد", "الكلية", "الرئتان", "القلب"],
      correctAnswer: "الكلية",
      explanation: "الكلية هي العضو المسؤول عن تنظيف الدم من الفضلات",
      subject: "أحياء",
      showAnswer: false
    },
    {
      question: "ما هو العضو المسؤول عن الهضم في الجسم؟",
      options: ["القلب", "الرئتان", "المعدة", "الدماغ"],
      correctAnswer: "المعدة",
      explanation: "المعدة هي العضو المسؤول عن الهضم في الجسم",
      subject: "أحياء",
      showAnswer: false
    },
    {
      question: "ما هو العضو المسؤول عن التحكم في جميع وظائف الجسم؟",
      options: ["القلب", "الرئتان", "الدماغ", "الكبد"],
      correctAnswer: "الدماغ",
      explanation: "الدماغ هو العضو المسؤول عن التحكم في جميع وظائف الجسم",
      subject: "أحياء",
      showAnswer: false
    },
    {
      question: "ما هو العضو المسؤول عن إنتاج الأنسولين؟",
      options: ["الكبد", "البنكرياس", "الكلية", "الرئتان"],
      correctAnswer: "البنكرياس",
      explanation: "البنكرياس هو العضو المسؤول عن إنتاج الأنسولين",
      subject: "أحياء",
      showAnswer: false
    },

    // لغة عربية - 4 أسئلة
    {
      question: "ما هو جمع كلمة 'كتاب'؟",
      options: ["كتب", "كتابات", "كتيبات", "مكتبة"],
      correctAnswer: "كتب",
      explanation: "جمع كلمة 'كتاب' هو 'كتب'",
      subject: "لغة عربية",
      showAnswer: false
    },
    {
      question: "ما هو المفعول به في الجملة: 'قرأ الطالب الكتاب'؟",
      options: ["قرأ", "الطالب", "الكتاب", "لا يوجد"],
      correctAnswer: "الكتاب",
      explanation: "المفعول به في الجملة هو 'الكتاب'",
      subject: "لغة عربية",
      showAnswer: false
    },
    {
      question: "ما هو الفاعل في الجملة: 'جاء المعلم'؟",
      options: ["جاء", "المعلم", "لا يوجد", "الجملة ناقصة"],
      correctAnswer: "المعلم",
      explanation: "الفاعل في الجملة هو 'المعلم'",
      subject: "لغة عربية",
      showAnswer: false
    },
    {
      question: "ما هو جمع كلمة 'مدرس'؟",
      options: ["مدرسون", "مدرسات", "مدرسين", "مدارس"],
      correctAnswer: "مدرسون",
      explanation: "جمع كلمة 'مدرس' هو 'مدرسون'",
      subject: "لغة عربية",
      showAnswer: false
    },

    // لغة إنجليزية - 3 أسئلة
    {
      question: "What is the past tense of 'go'?",
      options: ["goed", "went", "gone", "going"],
      correctAnswer: "went",
      explanation: "The past tense of 'go' is 'went'",
      subject: "لغة إنجليزية",
      showAnswer: false
    },
    {
      question: "What is the plural of 'child'?",
      options: ["childs", "children", "childes", "child"],
      correctAnswer: "children",
      explanation: "The plural of 'child' is 'children'",
      subject: "لغة إنجليزية",
      showAnswer: false
    },
    {
      question: "What is the opposite of 'big'?",
      options: ["large", "huge", "small", "tall"],
      correctAnswer: "small",
      explanation: "The opposite of 'big' is 'small'",
      subject: "لغة إنجليزية",
      showAnswer: false
    }
  ];

  // Mock API لحل الرموز


  // نظام تصحيح الأسئلة
  const [userAnswers, setUserAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [quizStats, setQuizStats] = useState(null);

  // Pagination للأسئلة
  const [currentPage, setCurrentPage] = useState(1);
  const questionsPerPage = 10;
  const totalPages = Math.ceil(questions.length / questionsPerPage);

  // حساب الأسئلة المعروضة
  const getCurrentQuestions = () => {
    const startIndex = (currentPage - 1) * questionsPerPage;
    const endIndex = startIndex + questionsPerPage;
    return questions.slice(startIndex, endIndex);
  };

  // دالة تغيير الصفحة
  const changePage = (page) => {
    setCurrentPage(page);
    // scroll to top of questions
    const questionsSection = document.querySelector('.questions-section');
    if (questionsSection) {
      questionsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // دالة التصحيح مع scroll
  const checkAnswers = () => {
    let correct = 0;
    let total = questions.length;
    const results = {};

    questions.forEach((question, index) => {
      const userAnswer = userAnswers[index];
      const correctAnswerIndex = question.options.indexOf(question.correctAnswer);
      const isCorrect = userAnswer === correctAnswerIndex;
      
      results[index] = {
        isCorrect,
        userAnswer: userAnswer !== undefined ? question.options[userAnswer] : 'لم تجب',
        correctAnswer: question.correctAnswer,
        explanation: question.explanation
      };

      if (isCorrect) correct++;
    });

    const percentage = Math.round((correct / total) * 100);
    
    setQuizStats({
      correct,
      total,
      percentage,
      results
    });
    
    setShowResults(true);

    // scroll to results
    setTimeout(() => {
      const resultsSection = document.querySelector('.quiz-results-section');
      if (resultsSection) {
        resultsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  // دالة إعادة الاختبار مع scroll
  const resetQuiz = () => {
    setUserAnswers({});
    setShowResults(false);
    setQuizStats(null);
    setCurrentPage(1);

    // scroll to questions
    setTimeout(() => {
      const questionsSection = document.querySelector('.questions-section');
      if (questionsSection) {
        questionsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };













      

     
    




  useEffect(() => {
    window.scrollTo(0, 0);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            
            // Start counter animation when stats section becomes visible
            if (entry.target.classList.contains(styles['library-stats'])) {
              const counters = entry.target.querySelectorAll('.counter');
              counters.forEach((counter, index) => {
                const target = parseFloat(counter.getAttribute('data-target'));
                const isDecimal = counter.hasAttribute('data-decimal');
                const duration = 2000; // 2 seconds
                const startTime = Date.now();
                
                const updateCounter = () => {
                  const elapsed = Date.now() - startTime;
                  const progress = Math.min(elapsed / duration, 1);
                  
                  // Easing function for smooth animation
                  const easeOutQuart = 1 - Math.pow(1 - progress, 4);
                  const current = target * easeOutQuart;
                  
                  if (progress < 1) {
                    if (isDecimal) {
                      counter.textContent = (current || 0).toFixed(1);
                    } else {
                      counter.textContent = Math.floor(current || 0).toLocaleString();
                    }
                    requestAnimationFrame(updateCounter);
                  } else {
                    if (isDecimal) {
                      counter.textContent = (target || 0).toFixed(1);
                    } else {
                      counter.textContent = (target || 0).toLocaleString();
                    }
                    // Add pulse animation when counter reaches target
                    counter.classList.add('animate');
                    setTimeout(() => counter.classList.remove('animate'), 500);
                  }
                };
                
                // Delay each counter slightly for staggered effect
                setTimeout(updateCounter, index * 200);
              });
            }
          }
        });
      },
      { threshold: 0.1 }
    );
    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const categories = [
    { id: "الكل", name: "الكل", icon: "📚" },
    { id: "رياضيات", name: "رياضيات", icon: "🔢" },
    { id: "علوم", name: "علوم", icon: "🔬" },
    { id: "لغة عربية", name: "لغة عربية", icon: "📖" },
    { id: "لغة إنجليزية", name: "لغة إنجليزية", icon: "🌍" },
    { id: "تاريخ", name: "تاريخ", icon: "📜" },
    { id: "جغرافيا", name: "جغرافيا", icon: "🌍" },
    { id: "فيزياء", name: "فيزياء", icon: "⚡" },
    { id: "كيمياء", name: "كيمياء", icon: "🧪" },
    { id: "أحياء", name: "أحياء", icon: "🧬" }
  ];

  const books = [
    {
      id: 1,
      title: "أساسيات الجبر الخطي",
      author: "د. أحمد محمد",
      category: "رياضيات",
      grade: "الصف الأول الثانوي",
      pages: 320,
      rating: 4.8,
      reviews: 156,
      downloads: 2847,
      cover: "📐",
      description: "كتاب شامل يغطي أساسيات الجبر الخطي والمصفوفات مع أمثلة عملية وتطبيقات واقعية",
      pdf: "/sample.pdf"
    },
    {
      id: 2,
      title: "الكيمياء العضوية المتقدمة",
      author: "د. فاطمة علي",
      category: "كيمياء",
      grade: "الصف الثاني الثانوي",
      pages: 450,
      rating: 4.9,
      reviews: 203,
      downloads: 3421,
      cover: "🧪",
      description: "دراسة شاملة للمركبات العضوية وتفاعلاتها مع التركيز على التطبيقات العملية",
      pdf: "/sample.pdf"
    },
    {
      id: 3,
      title: "قواعد اللغة العربية",
      author: "أ. سارة أحمد",
      category: "لغة عربية",
      grade: "الصف الأول الثانوي",
      pages: 280,
      rating: 4.7,
      reviews: 189,
      downloads: 2156,
      cover: "📖",
      description: "مرجع شامل لقواعد النحو والصرف مع أمثلة من القرآن الكريم والأدب العربي",
      pdf: "/sample.pdf"
    },
    {
      id: 4,
      title: "الفيزياء الكمية",
      author: "د. محمد حسن",
      category: "فيزياء",
      grade: "الصف الثالث الثانوي",
      pages: 380,
      rating: 4.6,
      reviews: 134,
      downloads: 1892,
      cover: "⚡",
      description: "مقدمة في ميكانيكا الكم ونظريات الفيزياء الحديثة مع التطبيقات العملية",
      pdf: "/sample.pdf"
    },
    {
      id: 5,
      title: "التاريخ الإسلامي",
      author: "د. خالد عبدالله",
      category: "تاريخ",
      grade: "الصف الثاني الثانوي",
      pages: 320,
      rating: 4.8,
      reviews: 167,
      downloads: 2341,
      cover: "📜",
      description: "تاريخ شامل للدولة الإسلامية من عهد الرسول صلى الله عليه وسلم حتى العصر الحديث",
      pdf: "/sample.pdf"
    },
    {
      id: 6,
      title: "جغرافيا العالم المعاصر",
      author: "د. نورا سعيد",
      category: "جغرافيا",
      grade: "الصف الأول الثانوي",
      pages: 290,
      rating: 4.5,
      reviews: 98,
      downloads: 1654,
      cover: "🌍",
      description: "دراسة شاملة لجغرافيا العالم مع التركيز على التحديات المعاصرة",
      pdf: "/sample.pdf"
    },
    {
      id: 7,
      title: "علم الأحياء الجزيئي",
      author: "د. أحمد إبراهيم",
      category: "أحياء",
      grade: "الصف الثالث الثانوي",
      pages: 410,
      rating: 4.9,
      reviews: 145,
      downloads: 1987,
      cover: "🧬",
      description: "دراسة متقدمة في علم الأحياء الجزيئي والهندسة الوراثية",
      pdf: "/sample.pdf"
    },
    {
      id: 8,
      title: "اللغة الإنجليزية المتقدمة",
      author: "أ. جيمس ويلسون",
      category: "لغة إنجليزية",
      grade: "الصف الثاني الثانوي",
      pages: 350,
      rating: 4.7,
      reviews: 178,
      downloads: 2678,
      cover: "🌍",
      description: "دورة متقدمة في اللغة الإنجليزية مع التركيز على المحادثة والكتابة الأكاديمية",
      pdf: "/sample.pdf"
    }
  ];

  const filteredBooks = books.filter(book => {
    const matchesCategory = selectedCategory === "الكل" || book.category === selectedCategory;
    const matchesSearch =
      searchQuery === "" ||
      book.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      book.author.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // Modal close handler
  const closeModal = () => setModalBook(null);

  // دالة فتح PDF Viewer
  const openPDF = (pdfUrl, fileName) => {
    // Navigate to PDF viewer page with query parameters
    navigate(`/pdf-viewer?url=${encodeURIComponent(pdfUrl)}&name=${encodeURIComponent(fileName)}`);
  };

  // دالة إغلاق PDF Viewer (لم تعد مطلوبة)
  const closePDF = () => {
    setShowPDFViewer(false);
    setSelectedPDF(null);
  };

  // Functions للأسئلة
  const handleAnswerSelect = (questionIndex, optionIndex) => {
    setUserAnswers(prev => ({
      ...prev,
      [questionIndex]: optionIndex
    }));
  };

  const toggleAnswer = (questionIndex) => {
    const updatedQuestions = [...questions];
    updatedQuestions[questionIndex].showAnswer = !updatedQuestions[questionIndex].showAnswer;
    // يمكن إضافة state لتحديث الأسئلة إذا لزم الأمر
  };

  return (
    <div className={`${styles['library-page']} ${isDarkMode ? 'dark-mode' : 'light-mode'} ${styles['library-container']}`}>
      {/* Floating Background Elements */}
      <div className={styles['floating-elements']}>
        <div className={styles['floating-element']}>📚</div>
        <div className={styles['floating-element']}>🔬</div>
        <div className={styles['floating-element']}>📖</div>
        <div className={styles['floating-element']}>🧪</div>
        <div className={styles['floating-element']}>⚡</div>
        <div className={styles['floating-element']}>🔢</div>
        <div className={styles['floating-element']}>📜</div>
        <div className={styles['floating-element']}>🌍</div>
      </div>

      <div className={`${styles['container']} container`}>
        {/* Header */}
        <div className={`${styles['library-header']} animate-on-scroll`}>
          <h1 className={styles['library-title']}>الاسئلة التدريبية الذكية</h1>
          <p className={styles['library-subtitle']}>اختبر معرفتك وحسن مهاراتك مع أسئلة تدريبية ذكية في جميع المواد</p>
        
        </div>

        {/* المساعد الذكي */}
        <div className={`${styles['ai-assistant-section']} animate-on-scroll`} style={{marginTop:"100px"}}>
          <h2 className={styles['section-title']}>🤖 المساعد الذكي</h2>
          <p className={styles['section-subtitle']}>أسئلة تدريبية ذكية وحل رموز لمساعدتك في الدراسة</p>
          
          <div className={`${styles['ai-tools-grid']} row`}>
            {/* أسئلة تدريبية ذكية */}
            <div className={`${styles['ai-tool-card']} col-lg-6 mx-auto`}>
              <div className={styles['tool-icon']}>🎯</div>
              <h3 className={styles['tool-title']}>أسئلة تدريبية ذكية</h3>
              <p className={styles['tool-description']}>احصل على أسئلة تدريبية مخصصة حسب مستواك ومادة الدراسة</p>
              <div className={styles['tool-input']}>
                <select className={styles['subject-select']}>
                  <option>اختر المادة</option>
                  <option>رياضيات</option>
                  <option>فيزياء</option>
                  <option>كيمياء</option>
                  <option>أحياء</option>
                  <option>لغة عربية</option>
                  <option>لغة إنجليزية</option>
                </select>
                <select className={styles['level-select']}>
                  <option>اختر المستوى</option>
                  <option>سهل</option>
                  <option>متوسط</option>
                  <option>صعب</option>
                </select>
                <button className={styles['generate-btn']} onClick={() => setShowQuestions(true)}>🎲 توليد أسئلة</button>
              </div>
              <div className={styles['tool-example']}>
                <strong>مثال:</strong> "5 أسئلة رياضيات مستوى متوسط"
              </div>
            </div>


          </div>

          {/* عرض الأسئلة */}
          {showQuestions && (
            <div className={styles['questions-section']}>
              <div className={styles['questions-header']}>
                <h3 className={styles['questions-title']}>الأسئلة التدريبية</h3>
                <div className={styles['questions-actions']}>
                  <button className={styles['check-answers-btn']} onClick={checkAnswers}>
                    ✅ تصحيح الإجابات
                  </button>
                  <button className={styles['reset-quiz-btn']} onClick={resetQuiz}>
                    🔄 إعادة الاختبار
                  </button>
                </div>
              </div>

              {/* إحصائيات سريعة */}
              {Object.keys(userAnswers).length > 0 && (
                <div className={styles['quick-stats']}>
                  <span>تم الإجابة على {Object.keys(userAnswers).length} من {questions.length} سؤال</span>
                </div>
              )}

              <div className={styles['questions-grid']}>
                {getCurrentQuestions().map((question, index) => {
                  const globalIndex = (currentPage - 1) * questionsPerPage + index;
                  return (
                    <div key={globalIndex} className={styles['question-card']}>
                      <div className={styles['question-header']}>
                        <span className={styles['question-number']}>السؤال {globalIndex + 1}</span>
                        <span className={styles['question-subject']}>{question.subject}</span>
                        {userAnswers[globalIndex] !== undefined && (
                          <span className={`${styles['answer-status']} ${userAnswers[globalIndex] === question.options.indexOf(question.correctAnswer) ? styles['correct'] : styles['incorrect']}`}>
                            {userAnswers[globalIndex] === question.options.indexOf(question.correctAnswer) ? '✅' : '❌'}
                          </span>
                        )}
                      </div>
                      <div className={styles['question-content']}>
                        <h4>{question.question}</h4>
                        <div className={styles['options']}>
                          {question.options.map((option, optIndex) => (
                            <label key={optIndex} className={`${styles['option']} ${userAnswers[globalIndex] === optIndex ? styles['selected'] : ''}`}>
                              <input 
                                type="radio" 
                                name={`question-${globalIndex}`}
                                value={optIndex}
                                checked={userAnswers[globalIndex] === optIndex}
                                onChange={() => handleAnswerSelect(globalIndex, optIndex)}
                                className="mx-2"
                              />
                              <span>{option}</span>
                            </label>
                          ))}
                        </div>
                        {question.showAnswer && (
                          <div className={styles['answer-section']}>
                            <div className={styles['correct-answer']}>
                              <strong>الإجابة الصحيحة:</strong> {question.correctAnswer}
                            </div>
                            <div className={styles['explanation']}>
                              <strong>الشرح:</strong> {question.explanation}
                            </div>
                          </div>
                        )}
                        <button 
                          className={styles['show-answer-btn']}
                          onClick={() => toggleAnswer(globalIndex)}
                        >
                          {question.showAnswer ? 'إخفاء الإجابة' : 'عرض الإجابة'}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className={styles['pagination-container']}>
                  <div className={styles['pagination-info']}>
                    الصفحة {currentPage} من {totalPages} • 
                    الأسئلة {((currentPage - 1) * questionsPerPage) + 1} - {Math.min(currentPage * questionsPerPage, questions.length)} من {questions.length}
                  </div>
                  <div className={styles['pagination-buttons']}>
                    <button 
                      className={styles['pagination-btn']}
                      onClick={() => changePage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      ← السابق
                    </button>
                    
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                      <button
                        key={page}
                        className={`${styles['pagination-btn']} ${currentPage === page ? styles['active'] : ''}`}
                        onClick={() => changePage(page)}
                      >
                        {page}
                      </button>
                    ))}
                    
                    <button 
                      className={styles['pagination-btn']}
                      onClick={() => changePage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      التالي →
                    </button>
                  </div>
                </div>
              )}

              {/* نتائج التصحيح */}
              {showResults && quizStats && (
                <div className={styles['quiz-results-section']}>
                  <div className={styles['results-summary']}>
                    <h3 className={styles['results-title']}>🎯 نتائج الاختبار</h3>
                    <div className={styles['stats-grid']}>
                      <div className={styles['stat-item']}>
                        <div className={styles['stat-number']}>{quizStats.total}</div>
                        <div className={styles['stat-label']}>إجمالي الأسئلة</div>
                      </div>
                      <div className={`${styles['stat-item']} ${styles['correct']}`}>
                        <div className={styles['stat-number']}>{quizStats.correct}</div>
                        <div className={styles['stat-label']}>إجابات صحيحة</div>
                      </div>
                      <div className={`${styles['stat-item']} ${styles['incorrect']}`}>
                        <div className={styles['stat-number']}>{quizStats.total - quizStats.correct}</div>
                        <div className={styles['stat-label']}>إجابات خاطئة</div>
                      </div>
                      <div className={`${styles['stat-item']} ${styles['percentage']}`}>
                        <div className={styles['stat-number']}>{quizStats.percentage}%</div>
                        <div className={styles['stat-label']}>النسبة المئوية</div>
                      </div>
                    </div>
                  </div>

                  <div className={styles['detailed-results']}>
                    <h4>📋 تفاصيل الإجابات:</h4>
                    <div className={styles['results-list']}>
                      {Object.entries(quizStats.results).map(([index, result]) => (
                        <div key={index} className={`${styles['result-item']} ${result.isCorrect ? styles['correct'] : styles['incorrect']}`}>
                          <div className={styles['result-header']}>
                            <span className={styles['question-num']}>السؤال {parseInt(index) + 1}</span>
                            <span className={`${styles['result-status']} ${result.isCorrect ? styles['correct'] : styles['incorrect']}`}>
                              {result.isCorrect ? '✅ صحيح' : '❌ خطأ'}
                            </span>
                          </div>
                          <div className={styles['result-details']}>
                            <div><strong>إجابتك:</strong> {result.userAnswer}</div>
                            <div><strong>الإجابة الصحيحة:</strong> {result.correctAnswer}</div>
                            <div className={styles['result-explanation']}>
                              <strong>الشرح:</strong> {result.explanation}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className={styles['results-actions']}>
                    <button className={styles['reset-quiz-btn']} onClick={resetQuiz}>
                      🔄 إعادة الاختبار
                    </button>
                    <button className={styles['show-all-answers-btn']} onClick={() => questions.forEach((_, i) => toggleAnswer(i))}>
                      👁️ عرض جميع الإجابات
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}


        </div>
      </div>

      {/* Book Preview Modal */}
      {modalBook && (
        <div className={styles['library-modal-overlay']} onClick={closeModal}>
          <div className={styles['library-modal']} onClick={e => e.stopPropagation()}>
            <button className={styles['close-modal-btn']} onClick={closeModal}>×</button>
            <div className={styles['modal-book-icon']}>{modalBook.cover}</div>
            <h2 className={styles['modal-book-title']}>{modalBook.title}</h2>
            <div className={styles['modal-book-author']}>تأليف: {modalBook.author}</div>
            <div className={styles['modal-book-meta']}>
              <span>{modalBook.category}</span> | <span>{modalBook.grade}</span>
            </div>
            <div className={styles['modal-book-pages']}>عدد الصفحات: {modalBook.pages}</div>
            <div className={styles['modal-book-description']}>{modalBook.description}</div>
            <div className={`${styles['modal-book-actions']} mt-3`}>
              <a
                className={styles['download-btn']}
                href={modalBook.pdf}
                download={modalBook.title + ".pdf"}
                target="_blank"
                rel="noopener noreferrer"
              >⬇️ تحميل الكتاب</a>
              <a
                className={styles['preview-btn']}
                href={modalBook.pdf}
                target="_blank"
                rel="noopener noreferrer"
              >👁️ فتح نسخة PDF</a>
            </div>
          </div>
        </div>
      )}

      {/* SVG للخطوط المتصلة بين الكتب */}
      <div className={styles['books-constellation-container']}>
        <svg className={styles['books-constellation-bg']} width="100%" height="100%">
          {filteredBooks.map((book, i) => {
            if (i === 0) return null;
            // خطوط بين كل كتاب والذي قبله
            const x1 = 200 + 180 * Math.cos((2 * Math.PI * (i-1)) / filteredBooks.length);
            const y1 = 200 + 180 * Math.sin((2 * Math.PI * (i-1)) / filteredBooks.length);
            const x2 = 200 + 180 * Math.cos((2 * Math.PI * i) / filteredBooks.length);
            const y2 = 200 + 180 * Math.sin((2 * Math.PI * i) / filteredBooks.length);
            return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#017FD2" strokeWidth="2" opacity="0.3" strokeDasharray="8 4">
              <animate attributeName="stroke-dashoffset" values="0;12;0" dur="2s" repeatCount="indefinite" />
            </line>;
          })}
        </svg>
      </div>

      {/* PDF Viewer */}
      {/* PDF Viewer is now handled by navigation */}
    </div>
  );
}

export default SmartQuestions; 